import { useContext } from 'react'

import PermissionContext from './PermissionContext'

const useIsAllowedTo = () => {
  const { isAllowedTo } = useContext(PermissionContext)

  return isAllowedTo
}

export { useIsAllowedTo }
